(function(){
    'use strict'

    angular
    .module('app.periodos')
    .controller('Periodos', Periodos);

    Periodos.$inject = ['$animationsSrv', 'PeriodosService', 'logger', '$location', 'UserInfoService'];

    function Periodos($animationsSrv, PeriodosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.periodos = [];
        vm.title = 'Periodos';

        vm.goToEdit = function(periodo){
            
            var path = '/editar-periodo/';

            if(periodo){
                $location.path(path + periodo.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = PeriodosService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(periodos){
                vm.periodos = periodos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los periodos.');
                        break;
                }
            });
        };

        vm.delete = function(periodo){
            var promise = PeriodosService.remove(periodo);
            
            promise
            .then(function(response){
                vm.periodos = vm.periodos.filter(function(g) {
                    return g.id !== periodo.id;
                });
                logger.success('Periodo eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el periodo');
                        break;
                }
                
            });   
        };

    }
})();